type OtpCredential = Credential & { code?: string };

export async function waitForSmsCode(signal: AbortSignal): Promise<string | null> {
  if (!("OTPCredential" in window)) return null;
  try {
    const credential = (await navigator.credentials.get({
      otp: { transport: ["sms"] },
      signal,
    } as CredentialRequestOptions)) as OtpCredential | null;
    return credential?.code ?? null;
  } catch {
    return null;
  }
}
